<template>
    <div>
        <router-link v-if="!row.is_deleted && $can('manage-user-category', 'user')" :to="'/update-group/' + row.id + '/' + cat_id" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
            <span class="tooltip-text">{{ $t('btn.edit') }}</span>
            <i class="fa fa-edit"></i>
        </router-link>

        <a  v-if="row.is_deleted && $can('manage-user-category', 'user')" href="#" v-on:click.prevent="restoreGroup" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
            <span class="tooltip-text">{{ $t('btn.restore') }}</span>
            <i class="fa fa-sync-alt"></i>
        </a>

        <a v-else-if="$can('manage-user-category', 'user')" href="#" v-on:click.prevent="deleteGroup" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
            <span class="tooltip-text">{{ $t('btn.delete') }}</span>
            <i class="fa fa-trash"></i>
        </a>

    </div>
</template>

<script>
    import $ from 'jquery'
    import Vue from 'vue'
    import { userService } from '@/common/api.service'
    import toastr from 'toastr'
    import {i18n} from "@/plugins/i18n";
    import {KTApp} from "@/plugins/core/app";
    import route from '@/router'
    export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        selector() {
            return $('tr[data-row="'+this.index+'"')
    },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods : {
        deleteGroup(e) {
            userService.deleteGroup(this.row.id)
            .then(response => {
                this.toastr.success(response.data.message);
                this.row.is_deleted = true;
            })
            .catch(({response}) => {
                this.toastr.error(i18n.t('message.an_error_accord'))
            })
        },

        restoreGroup(e) {
            userService.restoreGroup(this.row.id)
            .then(response => {
                    this.toastr.success(response.data.message)
                    this.row.is_deleted = false;
            })
            .catch(({response}) => {
                this.toastr.error(i18n.t('message.an_error_accord'))
            })
        }
    },
    data() {
        return {
            cat_id: route.history.current.params.cat_id
        }
    }
    })
</script>

<style>
.special-tooltip{
    position: relative;
    display: inline-block;
}
.special-tooltip .tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    min-width: 60px !important;
}
.special-tooltip .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    /*margin-left: -5px;*/
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}
.special-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}

</style>